<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card>
                <v-toolbar dark color="blue">
                    <v-btn icon dark @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Cotización Planilla de Características Técnicas</v-toolbar-title>
                    <v-spacer></v-spacer>
                    Código: {{ codgral }}
                    <v-spacer></v-spacer>
                    <!-- <v-divider></v-divider> -->
                    <v-btn icon @click="exportarPDF()">
                        <v-icon>mdi-file-pdf-box</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="2" md="2">
                            <h6><b> Factibilidad:</b> {{ cotizacion.fact }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Cliente: {{ cotizacion.cliente }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Obra: {{ cotizacion.obra }}</h6>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Responsable Ing. Producto: {{ cotizacion.resptec }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Responsable Comercial: {{ cotizacion.respcom }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Fecha: {{ cotizacion.fecha }}</h6>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card>
                <v-data-table dense :headers="headers" :items="cotizacion.productocostos" locale="es-ar"
                    class="elevation-1" hide-default-footer :items-per-page="100" :footer-props="{
        itemsPerPageText: 'Items por página',
    }">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Costos</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template slot="body.append">
                        <tr>
                            <th>TOTAL</th>
                            <th>-</th>
                            <th>-</th>
                            <th>-</th>
                            <th>$ {{ cotizacion.totalpesos }}</th>
                            <th>U$S {{ cotizacion.totaldolares }}</th>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
            <v-card>
                <v-data-table dense :headers="headersE" :items="cotizacion.productoestim" locale="es-ar"
                    class="elevation-1" hide-default-footer :items-per-page="100" :footer-props="{
        itemsPerPageText: 'Items por página',
    }">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Estimación de Ingeniería</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template slot="body.append">
                        <tr>
                            <th>TOTAL</th>
                            <th>$ {{ cotizacion.totalpesosE }}</th>

                        </tr>
                    </template>
                </v-data-table>
            </v-card>
            <v-card color="light-grey">
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="2" md="2">
                            <h6><b> Plazo:</b> {{ cotizacion.plazo }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Observaciones: {{ cotizacion.observ }}</h6>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <h6>Mail enviado a: {{ cotizacion.mail }}</h6>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card v-if="fileInfos.length > 0" class="mx-auto">
                <v-list>
                    <v-subheader>Lista de archivos</v-subheader>
                    <v-list-item-group color="primary">
                        <v-list-item v-for="(file, index) in cotizacion.informes" :key="index">
                            <v-list-item-content>
                                <v-list-item-title class="mb-3">
                                    <v-icon color="red"
                                        @click="borrarArchivo(file.descripcion, index)">mdi-close</v-icon>
                                    <a target="_blank" :href="'https://api.icssa.com.ar/informes/' + file.descripcion
        ">{{ file.titulo }}</a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>

        </v-form>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import readXlsFile from "read-excel-file";
import { cloneDeep } from 'lodash';
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        valid: false,
        lazy: false,
        usuario: "",
        fileInfos: [],
        cotizacion: [],
        // factibilidad: "",
        // cliente: "",
        // obra: "",
        // respcom: "",
        // resptec: "",
        // fecha: "",
        // comercial: [],
        // cotiz: [],
        // estim: [],
        // totalpesos: "0",
        // totaldolares: "0",
        // totalpesosE: "0",
        // plazo: "",
        // observ: "",
        // direcciones: [],
        // direccion: "",
        // correos: "",
        // destinatarios: [],
        // mail: [{ address: "" }],
        // costos: [],
        // estimacion: [],
        headers: [
            { text: "Descripción", value: "descrip", sortable: false },
            { text: "Cantidad", value: "cantidad", sortable: false },
            { text: "Costo Unitario Pesos", value: "costopesos", sortable: false },
            { text: "Costo Unitario Dólares", value: "costodolares", sortable: false },
            { text: "Costo Total Pesos", value: "subtotalpesos", sortable: false },
            { text: "Costo Total Dólares", value: "subtotaldolares", sortable: false },
        ],
        headersE: [
            { text: "Estimación", value: "descrip", sortable: false },
            { text: "Costo Unitario Pesos", value: "costopesos", sortable: false },
        ],
    }),

    props: ["visible", "codgral"],
    computed: {
        show: {
            get() {
                //this.mostrar = true;
                this.elaboro = this.$store.state.nombre.toString().trim();
                this.vaciarListado();
                if (this.codgral != "") {

                    this.cargarInforme();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            this.cotizacion = [];
        },

        cargarInforme() {
            const codgral = this.codgral;
            let self = this;
            axios
                .get("/Producto/CargarInforme?", {
                    params: {
                        codgral: codgral,
                        tipo: "I",
                    },
                })
                .then((response) => {

                    self.cotizacion = response.data;
                    self.fileInfos = response.data.informes;
                    // self.obra = response.data.obra;
                    // self.respcom = response.data.respcom;
                    // self.resptec = response.data.resptec;
                    // self.factibilidad = response.data.fact;
                    // self.fecha = response.data.fecha;
                    // self.costos = response.data.productocostos;
                    // self.estimacion = response.data.productosestim;
                    // self.totalpesos = response.data.totalpesos;
                    // self.totaldolares = response.data.totaldolares;
                    // self.totalpesosE = response.data.totalpesosE;
                    // self.plazo = response.data.plazo;
                    // self.observ = response.data.observ;
                    // self.mail = response.data.mail;
                    console.log(self.cotizacion);

                })
                .catch((error) => {
                    self.cotizacion = [];
                    console.log(error);
                });
        },

        vaciarListado() {
            console.log("Vaciar")
            this.cotizacion = [];
        },

        exportarPDF() {
            var vm = this;
            var finalO = 0;
            var columnsC = [
                { title: "Descripción", dataKey: "descrip" },
                { title: "Cantidad", dataKey: "cantidad" },
                { title: "Costo Unitario Pesos", dataKey: "costopesos" },
                { title: "Costo Unitario Dólares", dataKey: "costodolares" },
                { title: "Costo Total Pesos", dataKey: "subtotalpesos" },
                { title: "Costo Total Dólares", dataKey: "subtotaldolares" },
            ];

            var columnsE = [
                { title: "Descripción", dataKey: "descrip" },
                { title: "Costo Unitario Pesos", dataKey: "costopesos" },
            ];

            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);
            doc.line(10, 11, 10, 41);
            doc.line(40, 26, 200, 26);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(12);
            doc.text("RESPUESTA PLANILLA CARACTERÍSTICAS TÉCNICAS", 45, 20);
            doc.setFontSize(10);
            doc.text("N°: " + vm.codgral, 180, 20);
            //doc.text("EI Rev. ", 173, 35);
            doc.line(40, 11, 40, 41);
            doc.line(165, 11, 165, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);

            doc.setFontSize(11);
            doc.text("Factibilidad: " + vm.cotizacion.fact, 15, 50);
            doc.text("Cliente: " + vm.cotizacion.cliente, 15, 55);
            doc.text("Obra: " + vm.cotizacion.obra, 15, 60);
            doc.text("Responsable Comercial: " + vm.cotizacion.respcom, 15, 65);
            doc.text("Responsable Ing. Producto: " + vm.cotizacion.resptec, 15, 70);
            doc.text("Fecha: " + vm.cotizacion.fecha, 15, 75);

            doc.text("COSTOS ", 15, 85);

            //doc.autoTable(columnsC, vm.cotizacion.productocostos, { theme: 'grid', foot: [['TOTAL', '', '', '', '$ ' + vm.cotizacion.totalpesos, 'U$S ' + vm.cotizacion.totaldolares]], margin: { top: 90 } });
            doc.autoTable(columnsC, vm.cotizacion.productocostos, { theme: 'grid', foot: [['TOTAL', '', '', '', '$ ' + vm.cotizacion.totalpesos, 'U$S ' + vm.cotizacion.totaldolares]], startY: 90, });

            doc.text("ESTIMACIÓN INGENIERÍA ", 15, doc.autoTable.previous.finalY + 20);

            doc.autoTable(columnsE, vm.cotizacion.productoestim, { theme: 'grid', foot: [['TOTAL', '$ ' + vm.cotizacion.totalpesosE]], startY: doc.autoTable.previous.finalY + 25 });

            doc.text("Plazo: " + vm.cotizacion.plazo, 15, doc.autoTable.previous.finalY + 20);
            doc.text("Observaciones: ", 15, doc.autoTable.previous.finalY + 25);
            var textoSplit = vm.cotizacion.observ.split(/\r|\n\r|\n/);
            finalO = doc.autoTable.previous.finalY + 30;
            console.log("Frase: " + textoSplit[1]);
            for (var i = 0; i < textoSplit.length; i++) {
                finalO = finalO + 5;
                if (textoSplit[i].length < 75) {
                    doc.text(textoSplit[i], 10, finalO);
                } else {
                    var lineSplit = textoSplit[i].split(" ");
                    var linePrint = "";
                    var lineTemp = "";
                    for (var j = 0; j < lineSplit.length; j++) {
                        if (linePrint.length >= 72) {
                            console.log("linea: " + lineSplit[j]);
                            if (j == lineSplit.length - 1)
                                doc.text(lineSplit[j], 10, finalO + 5);

                            lineTemp = linePrint + lineSplit[j];
                            if (lineTemp.length < 72) {
                                doc.text(lineTemp, 10, finalO);
                                linePrint = "";
                            } else {
                                doc.text(linePrint, 10, finalO);
                                linePrint = lineSplit[j] + " ";
                            }
                            finalO = finalO + 5;

                            if (finalO > 285) {
                                doc.addPage();
                                finalO = 20;
                            }
                        } else {
                            linePrint = linePrint + lineSplit[j] + " ";
                            if (j == lineSplit.length - 1) {
                                doc.text(linePrint, 10, finalO);
                                if (finalO > 285) {
                                    doc.addPage();
                                    finalO = 20;
                                }
                            }
                        }
                    }
                }
            }

            doc.output('dataurlnewwindow');

            doc.save("CotizacionIngProducto" + vm.codgral + ".pdf");
        },
    },
};
</script>
